<script setup>
import {onBeforeMount, ref, nextTick} from "vue";
import router from "@/router/index.js";
import createPhotographer from "./components/createPhotographer/index.vue"
import {getRoute} from "@/hooks/getRoute.js";
import {editServiceProviderIgnoreTenant, getServiceProviderIgnoreTenant} from "@/api/serviceProvider/ignoreTenant.js";

const {route} = getRoute()

// 服务商（摄影师）ID
const providerId = ref()
onBeforeMount(async () => {
  if (!route.query.tenantId) {
    loading.value = true
    ElMessage.error("暂无摄影服务商信息")
  } else if (!route.query.providerId) {
    loading.value = true
    ElMessage.error("暂无摄影师信息")
  } else {
    ruleForm.value.tenantId = route.query.tenantId
    ruleForm.value.storeId = route.query.storeId
    providerId.value = route.query.providerId
    await getDetail()
  }
})
// 加载状态
const loading = ref(false)
/*表单信息相关*/
// 表单
const ruleForm = ref({
  tenantId: null,
  storeId: null,
  avatar: null,
  name: null,
  nameEn: null,
  phone: null,
  gender: null,
  summary: null,
  summaryEn: "Coming Soon ...",
  description: null,
  descriptionEn: null,
  providerType: "PHOTOGRAPHER",
  tagIdList: [],
  photographerPictureWorks: [],
  photographerVideoWorks: [],
  skillCertificates: []
})
// 处理创建摄影师
const handleUpdatePhotographer = async () => {
  try {
    loading.value = true
    await editServiceProviderIgnoreTenant(ruleForm.value)
    ElMessage.success("修改成功")
    router.back()
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
// 创建摄影师组件锚点
const createPhotographerRef = ref()
// 获取摄影师信息
const getDetail = async () => {
  try {
    loading.value = true
    ruleForm.value = await getServiceProviderIgnoreTenant(providerId.value)
    createPhotographerRef.value.handleReviewPic([ruleForm.value.avatar])
    createPhotographerRef.value.handleReviewPhotographerWorksPic(ruleForm.value.photographerPictureWorks)
    createPhotographerRef.value.handleReviewPhotographerWorksVid(ruleForm.value.photographerVideoWorks)
    createPhotographerRef.value.handleReviewSkillCertificatesPic(ruleForm.value.skillCertificates)
    nextTick(() => {
      createPhotographerRef.value.handleReviewTagList()
    })
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
</script>

<template>
  <createPhotographer ref="createPhotographerRef" v-loading="loading" v-model="ruleForm" :is-edit="true" @success="handleUpdatePhotographer"></createPhotographer>
</template>

<style lang="scss" scoped>

</style>
